require('./scss/vendor/vendor.scss');
let ctx = require.context('./js/vendor', false, /\.ts|js$/);
ctx.keys().forEach(ctx);
